import React from "react";
import { Calendar, Trophy, Users, Share2, Bell, Star } from "lucide-react";
const OrganiserTeamSection = () => {
  return (
<section className="bg-blue-50 py-12">
  <div className="max-w-6xl mx-auto px-4 text-center">
    <h2 className="text-xl font-bold italic text-center mb-10">
      🙌 Why Organizers & Teams Love It
    </h2>

    <div className="grid md:grid-cols-2 gap-8">
      {/* Organizers Card */}
      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h3 className="text-xl font-semibold text-indigo-600 mb-6 flex items-center justify-center gap-2">
          <Users className="w-6 h-6 text-indigo-600" /> Organizers
        </h3>
        <ul className="text-gray-700 space-y-4 text-left">
          <li className="flex items-start gap-3">
            <Calendar className="w-6 h-6 text-green-500 flex-shrink-0" />
            <span>Save time and hassle with automated scheduling</span>
          </li>
          <li className="flex items-start gap-3">
            <Trophy className="w-6 h-6 text-yellow-500 flex-shrink-0" />
            <span>
              Boost visibility and fan engagement. Digital certificates for winners, runners-up, and top players.
            </span>
          </li>
          <li className="flex items-start gap-3">
            <Share2 className="w-6 h-6 text-blue-500 flex-shrink-0" />
            <span>Manage everything in one place – teams, matches, scores, and media</span>
          </li>
        </ul>
      </div>

      {/* Teams & Players Card */}
      <div className="p-6 bg-gradient-to-r from-blue-100 via-blue-200 to-blue-200 shadow rounded-xl">
        <h3 className="text-xl font-semibold text-red-500 mb-6 flex items-center justify-center gap-2">
          <Star className="w-6 h-6 text-red-500" /> Teams & Players
        </h3>
        <ul className="text-gray-700 space-y-4 text-left">
          <li className="flex items-start gap-3">
            <Users className="w-6 h-6 text-green-500 flex-shrink-0" />
            <span>Easy sign-up and match tracking</span>
          </li>
          <li className="flex items-start gap-3">
            <Bell className="w-6 h-6 text-indigo-500 flex-shrink-0" />
            <span>Get real-time updates and notifications</span>
          </li>
          <li className="flex items-start gap-3">
            <Trophy className="w-6 h-6 text-yellow-500 flex-shrink-0" />
            <span>Showcase performance and win awards</span>
          </li>
        </ul>
      </div>
    </div>
  </div>
</section>
  );
};

export default OrganiserTeamSection;